import { z } from 'zod';
export var MeetingSeatTermStatus;
(function (MeetingSeatTermStatus) {
    MeetingSeatTermStatus["Vacant"] = "vacant";
    MeetingSeatTermStatus["Nominated"] = "nominated";
    MeetingSeatTermStatus["Active"] = "active";
})(MeetingSeatTermStatus || (MeetingSeatTermStatus = {}));
// Create validation and DTO type
export const meetingBodySeatTermCreateSchema = z.object({
    number: z.number('Term number is required'),
    startDate: z.iso.datetime('Start date is required'),
    endDate: z.iso.datetime('End date is required'),
    status: z.enum(MeetingSeatTermStatus),
    vacancyDate: z.iso.datetime().nullable().optional(),
});
// Update validation and DTO type
export const meetingBodySeatTermUpdateSchema = meetingBodySeatTermCreateSchema.partial();
